import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { authMe } from '../utils/api';

const AuthContext = createContext(null);
const BASE_URL = process.env.REACT_APP_API_URL || '';

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('sp_token');
    if (token) {
      authMe()
        // .then(({ data }) => setUser(data))
        .then(({ data }) => setUser({ ...data, schoolNames: data.schoolNames || [] }))
        .catch(() => localStorage.removeItem('sp_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const { data } = await axios.post(`${BASE_URL}/api/auth/login`, { username, password });
    localStorage.setItem('sp_token', data.token);
    // setUser(data.user);
    setUser({ ...data.user, schoolNames: data.user.schoolNames || [] });
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('sp_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
